<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .modal-content {
    height: 100%;
    display: flex;
    flex-direction: column;

    .body {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(16px);
      padding: utils.in_rem(16px) utils.in_rem(32px);
      overflow-y: auto;

      .autocomplete {
        display: flex;
        flex-direction: column;
      }
    }

    .footer {
      display: flex;
      justify-content: flex-end;
      gap: utils.in_rem(8px);
      padding: utils.in_rem(16px) utils.in_rem(24px);
    }
  }
</style>

<script>
  import { showToast, ToastError } from "@sourcewhale/core";
  import { addManualToDo } from "@sourcewhale/shared/src/svelte/api/todos";
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import Label from "@sourcewhale/shared/svelte-design-system/components/atoms/InputLabels/Label.svelte";
  import SingleSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/SingleSelectDropdown/SingleSelectDropdown.svelte";
  import TextInput from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/TextInput.svelte";
  import Modal from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/Modal.svelte";
  import DatePicker from "@sourcewhale/shared/svelte-design-system/components/molecules/TimeInputs/DatePicker/DatePicker.svelte";
  import CandidateAutocomplete from "../../components/CandidateAutocomplete.svelte";
  import { todosQueryParams } from "../../pages/Todo/todosQueryParams.svelte";

  const taskItems = [
    { id: "phoneCall", label: "Phone Call" },
    { id: "email", label: "Email" },
    { id: "sendInmail", label: "Send InMail" },
    { id: "linkedinConnectionRequest", label: "Connection Request" },
    { id: "meeting", label: "Meeting" },
    { id: "generalTask", label: "General Task" },
  ];

  const priorityItems = [
    { id: "low", label: "Low" },
    { id: "medium", label: "Medium" },
    { id: "high", label: "High" },
  ];

  let {
    actionedFrom = null,
    selectedCandidateId = null,
    onclose = () => {},
  } = $props();

  let task = $state("");
  let candidateId = $state(selectedCandidateId);
  let toDoType = $state(null);
  let priority = $state("medium");
  let selectedDate = $state(null);
  const dueDate = $derived(
    selectedDate ? Math.floor(selectedDate.getTime() / 1000) : null
  );
  let notes = $state("");

  const disabled = $derived(!(task && candidateId && dueDate && toDoType));

  const headerStyle = "padding: 24px 32px 16px";

  const onSubmit = async () => {
    try {
      await addManualToDo({
        task,
        candidateId,
        toDoType,
        priority,
        dueDate,
        notes,
      });
      showToast({ title: "Task created", type: "success" });
      if (actionedFrom === "manualToDoPage") {
        setTimeout(() => todosQueryParams.reset(true), 3000);
      }
      onclose();
    } catch (error) {
      if (error instanceof ToastError) {
        error.title = "Error creating task";
        showToast(error);
        return;
      }
      throw error;
    }
  };
</script>

<Modal size="medium" {headerStyle} {onclose}>
  <h2 slot="header">Create a new task</h2>
  <div class="modal-content">
    <div class="body">
      <TextInput label="Task" placeholder="Enter task" bind:value={task} />
      {#if !selectedCandidateId}
        <div class="autocomplete">
          <Label label="Contact" />
          <CandidateAutocomplete bind:candidateId />
        </div>
      {/if}
      <SingleSelectDropdown
        label="Task type"
        items={taskItems}
        bind:selected={toDoType}
      />
      <SingleSelectDropdown
        label="Priority"
        items={priorityItems}
        bind:selected={priority}
      />
      <DatePicker
        label="Date due"
        allowFuture={true}
        allowPast={false}
        bind:selectedDate
      />
      <TextInput label="Notes" kind="textarea" bind:value={notes} />
    </div>
    <div class="footer">
      <Button kind="tertiary" onclick={onclose}>Cancel</Button>
      <Button onclick={onSubmit} class={disabled ? "disabled" : ""} {disabled}>
        Save
      </Button>
    </div>
  </div>
</Modal>
